import React, {useEffect, useState} from 'react';
import CalendarItem from '../../../models/calendarItemModel';
import {ResponseData} from '@dvrd/fetch';
import YearCalendar from './yearCalendar';
import IDate from '@dvrd/idate';

function getCurrentPeriod(): [IDate, IDate] {
    const today = IDate.now();
    const from = today.clone().set({month: 9, day: 1});
    const to = today.clone().add(1, 'year').set({month: 8, day: 31});
    return [from, to];
}

export default function YearCalendarController() {
    const [items, setItems] = useState<Array<CalendarItem>>([]);
    const [loading, setLoading] = useState(true);

    function loadItems() {
        const [fromDate, toDate] = getCurrentPeriod();
        CalendarItem.getAll(fromDate, toDate, (items: Array<CalendarItem>, success: boolean, data: ResponseData) => {
            setLoading(false);
            if (success) setItems(items);
            // Report else
        });
    }

    useEffect(() => {
        loadItems();
    }, []);

    return (
        <YearCalendar items={items} loading={loading}/>
    );
}

YearCalendarController.displayName = 'AgendaController';